import { Loader2 } from "lucide-react";
import { useTranslation } from "react-i18next";

/* eslint-disable react/react-in-jsx-scope */
const MapLoader = ({ isFullscreen }: { isFullscreen?: boolean }) => {
  const { t } = useTranslation("submit", {
    keyPrefix: "project.map",
  });
  return (
    <div
      className="flex items-center justify-center"
      style={{
        height: isFullscreen ? "100vh" : "500px",
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        background: "rgba(0,0,0,0.2)",
        backgroundImage: "url(/map-loader.png)",
        backgroundSize: "100%",
        zIndex: 999998,
      }}
    >
      <div
        className="flex flex-col items-center justify-center text-lg text-background"
        style={{
          height: "500px",
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          background: "rgba(0,0,0,0.4)",
          zIndex: 9999,
        }}
      >
        <Loader2 className="animate-spin" size={30} />
        {t("Chargement de la carte")}
      </div>
    </div>
  );
};

export default MapLoader;
